// Copyright (c) Docugami, Inc. All rights reserved.

export enum OrganizationState {
    None = 0,
    Creating = 1,
    Created = 2,
    Deleting = 3,
    Deleted = 4,
    Migrating = 5,
    MigrationFailed = 8
}

/**
 * Some properties that the client should never use (like cosmos db info)
 * is omitted here intentionally.
 */
export interface Organization {
    id: string;
    organizationId: string;
    name: string;
    state: OrganizationState;
    creatorEmail: string;
    createOperationInstanceId: string;
    maxUsers?: number;
    expirationDate?: Date
    version: string;
}

export interface WaitlistResponse {
    status: string;
    organizationName: string;
}

export enum SubscriptionType {
    Trial = "Trial",
    Basic = "Basic",
    Team = "Team",
    Business = "Business",
    Enterprise = "Enterprise"
}

export enum SubscriptionStatus {
    Active = "Active",
    Canceled = "Canceled",
    PastDue = "PastDue",
    Incomplete = "Incomplete",
    IncompleteExpired = "IncompleteExpired",
    UserCanceled = "UserCanceled"
}

export interface OrganizationAccount {
    id: string;
    organizationId: string;
    subscription: Subscription;
    expired?: boolean;
    reachedPageLimit?: boolean;
    stripeCustomerId: string;
}

export interface Subscription {
    subscriptionType: SubscriptionType;
    subscriptionId: string;
    maxUsers?: number;
    maxPages?: number;
    processedPageCount: number;
    expirationDate?: Date;
    createdAt?: Date;
    maxPagesPerDocument?: number;
    status?: SubscriptionStatus;
    maxPagesQuota?: number;
}
